module.exports = new __parcel__URL__("issue-app-skeleton.exp.tpl.4aeaad6d.svg").toString();